import React, { useState } from 'react'
import { images } from '../../constants'
import { AppWrapper, MotionWrapper } from '../../HOC'
import { client } from '../../client'
import './footer.scss'

const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { username, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setLoading(true);

    const contact = {
      _type: 'contact',
      name: formData.username,
      email: formData.email,
      message: formData.message,
    };

    client.create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmitted(true);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <h2 className="head-text">Feel free to <span>Contact</span> Me</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href="mailto:j.matsaberidze31@gmail.com" className="p-text">j.matsaberidze31@gmail.com</a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="mobile" />
          <a href="tel: +995 598 14 60 03" className="p-text">(+995) 598-14-60-03</a>
        </div>
      </div>

      {!isFormSubmitted ? (
      <div className="app__footer-form app__flex">
        <div className="app__flex">
          <input 
            className="p-text" 
            type="text" 
            placeholder="Enter your name" 
            name="username" 
            value={username} 
            onChange={handleChangeInput} 
          />
        </div>
        <div className="app__flex">
            <input 
              className="p-text" 
              type="email" 
              placeholder="Enter your email" 
              name="email" 
              value={email} 
              onChange={handleChangeInput} 
            />
        </div>
        <div>
            <textarea
              className="p-text"
              placeholder="What's on your mind?"
              value={message}
              name="message"
              onChange={handleChangeInput}
            />
        </div>
          <button 
            type="button" 
            className="p-text" 
            onClick={handleSubmit}
          >
            {!loading ? 'Send Message' : 'Sending...'}
          </button>
        </div>
      ) : (
        <div>
          <h3 className="head-text" style={{ fontSize: '26px' }}>
            Thank you for getting in touch! I will reply you as soon as possible
          </h3>
      </div>
      )}
    </>
  )
}

export default AppWrapper(
  MotionWrapper(Footer, 'app__footer'),
  'contact',
  'app__whitebg'
)